import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import React from 'react';
import { MailboxesActionsType } from '@ukpostbox/client-data';
import { ContentLoader, DropdownMenuEntry } from '@ukpostbox/frontend-framework';
import { MailActionsIconMap } from '../../../_Global/Data/MailActionsIconMap';
import { useMailbox } from '../../Providers/NewMailboxProvider';

function MailboxesActionsMenu(props: MailboxesActionsType) {
	const { mailItemActionsStatus, selectionActions } = useMailbox();

	return mailItemActionsStatus === 'pending' ? (
		<ContentLoader childHeight='3em' childCount={4} />
	) : selectionActions.length === 0 ? (
		<div className='flex-column align-center justify-center faded p-md'>
			<FontAwesomeIcon icon={faGear} size='2x' />
			<h6 className='sm-sub-heading mt-sm mb-0'>No Actions Available</h6>
		</div>
	) : (
		<>
			{selectionActions.map((action) => (
				<DropdownMenuEntry
					key={`action-${action.name}`}
					icon={MailActionsIconMap[action.name]}
					disabled={action.disabled}
					title={action.name}
					onClick={() => (props.actionCallback ? props.actionCallback(action.transitionId) : null)}
				/>
			))}
		</>
	);
}

export default MailboxesActionsMenu;
